module.exports = __webpack_public_path__ + "img/2024-09-19e_1.3cb10782.jpg";